import { TFunction } from 'i18next';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { EmployeeNameCell } from './component';
import { ReceiptsRowViewModel } from '../../row/viewModel';
import { ReceiptsCellViewModel } from '../viewModel';
import { ManagedTableGridColDef } from '../../../../../lib/components/compound/table';

export class EmployeeNameCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get t() {
    return this.row.translate;
  }

  get cellValue() {
    return this.receipt.employeeName;
  }

  get value() {
    return this.cellValue;
  }

  get title() {
    return this.cellValue;
  }

  static buildColDef(t: TFunction): ManagedTableGridColDef {
    return {
      field: 'employeeName',
      headerName: t('employee:EMPLOYEES'),
      width: 130,
      flex: 1,
      renderCell: (params: GridRenderCellParams<EmployeeNameCellViewModel>) => (
        <EmployeeNameCell {...params} />
      ),
      getOrderingString: (desc = false) => {
        return `${desc ? '-' : ''}${[
          'employee__general_data__last_name',
          'employee__general_data__first_name'
        ].join(desc ? ',-' : ',')}`;
      }
    };
  }
}
